import moment, { Moment } from 'moment';
import { useState } from 'react';
import { IResponseDataBody } from 'services/response';
import appointmentApis from '../services/apis';
import { bookingV2LoadingRef } from './Loading';
type IInquiryCustomerHandler = {
  onStart?: (params: { startTime: string, endTime: string }) => void;
  onDone?: (data: Moment[]) => void;
};
const useInquiryDayOffs = (handler?: IInquiryCustomerHandler): [({
  data: Moment[];
}), (startTime: string, endTime: string) => Promise<void>] => {
  const [timeSlots, setTimeSlots] = useState<Moment[]>([]);
  const _debounce = async (startTime: string, endTime: string) => {
    bookingV2LoadingRef.current?.open();
    handler?.onStart?.({ startTime, endTime });
    try {
      const res: IResponseDataBody<string[]> = await appointmentApis.shopOffDay(startTime, endTime);
      const resData = res?.data?.data;
      if (resData) {
        const data = resData.map(o => moment(o, 'MM-DD-YYYY'));
        setTimeSlots(data);
        handler?.onDone?.(data);
      } else {
        handler?.onDone?.([]);
      }
    } catch (error) {
      handler?.onDone?.([]);
    } finally {
      bookingV2LoadingRef.current?.close();
    }
  };

  return [{ data: timeSlots }, _debounce];
};

export default useInquiryDayOffs;
